import { render, staticRenderFns } from "./ServiceAnamnez.vue?vue&type=template&id=6b860c23&scoped=true"
import script from "./ServiceAnamnez.vue?vue&type=script&lang=ts"
export * from "./ServiceAnamnez.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b860c23",
  null
  
)

export default component.exports